<template>
  <div class="follow_btn">
    <el-button
        v-if="!params.isFollow"
        class="create_follow"
        type="primary"
        :loading="loading_flag"
        @click="createFrontCollection"
    >关注</el-button>
    <el-button
        v-else
        class="cancel_follow"
        type="primary"
        :loading="loading_flag"
        @click="deleteFrontCollection"
    >已关注</el-button>
  </div>
</template>

<script>
  export default {
    props:{
      params:{},
      entity_type: {
        type: String,
        default: 'EntityTypeDesigner'
      }
    },
    data(){
      return{
        loading_flag: false,
      }
    },
    created(){

    },
    methods:{
      // 创建关注
      createFrontCollection() {
        this.loading_flag = true;
        let obj = {
          type: "CollectionTypeFollow",
          code: this.params.code,
          user_id: this.params.user, //避免自己关注自己的
          entity_type: this.entity_type
        };
        this.api.createFrontCollection(obj, true).then(res => {
          console.log(res);
          if (res.error.err_code !== 0) {
            this.loading_flag = false;
            return;
          }
          this.params.follow_count++;
          this.params.isFollow = true;
          this.loading_flag = false;
          this.$message.success("关注成功！");
        });
      },
      // 取消关注
      deleteFrontCollection() {
        this.loading_flag = true;
        let obj = {
          type: "CollectionTypeFollow",
          code: this.params.code,
          entity_type: this.entity_type
        };
        this.api.deleteFrontCollection(obj, true).then(res => {
          console.log(res);
          if (res.error.err_code !== 0) {
            this.loading_flag = false;
            return;
          }
          this.params.follow_count--;
          this.params.isFollow = false;
          this.loading_flag = false;
          this.$message.success(`已取消关注！`);
        });
      }
    }
  }
</script>

<style lang="scss">
.follow_btn{
  .cancel_follow {
    display: inline-block;
    padding-top: 4px;
    padding-bottom: 4px;
    border-radius: 50px;
    box-sizing: border-box;
    text-align: center;
    color: $color-gary3;
    border: 1px solid $color-gary4;
    background-color: #fff;
  }
  .create_follow {
    display: inline-block;
    padding-top: 4px;
    padding-bottom: 4px;
    border-radius: 50px;
    box-sizing: border-box;
    text-align: center;
    background: $color-default;
    color: #fff;
    border-color: $color-default;
  }
}
</style>
